/* eslint-disable import/no-anonymous-default-export */
import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const endpoint_one = process.env.REACT_APP_API_ENDPOINT_ONE;
const api_version = process.env.REACT_APP_API_VERSION;

export default {
  getAdminWebInfo: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/Get-lasmab-websiteinfo`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getWebInfoDetails: (token, type) =>
    axiosClient
      .get(`${endpoint_one}/api/v${api_version}/Website/${type}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),

  getRightsStaff: (token, staffId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/Rights/${staffId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getMenuItemsStaff: (token, staffId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/MenuItems/${staffId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getDashboardItemsStaff: (token, staffId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/DashboardItems/${staffId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getMenuItems: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/MenuItems`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getDashboardItems: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/DashboardItems`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getPriviledges: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/Priviledges`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getRights: (token) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/Rights`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  postUpdateRole: (token, data) => {
    // let data = {
    //   roleName,
    //   roleDescription,
    //   departmentId,
    //   categoryId,
    // };
    console.log(data, token);
    return axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelUserSetup/UpdateRole`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response);
  },

  postCreateRole: (token, data) => {
    // let data = {
    //   roleName,
    //   roleDescription,
    //   departmentId,
    //   categoryId,
    // };
    console.log(data, token);
    return axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelUserSetup/CreateRole`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  deleteControlPanelLasmabSetup: (id, token, type) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/${type}?id=${id}`,
        // data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  activateControlPanelLasmabSetup: (id, bool, token, type) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/${type}?NewsId=${id}&id=${id}&isActivated=${bool}&isActivate=${bool}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  postControlPanelLasmabSetup: (data, token, type) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/${type}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // Staff Account Setup
  postActivateStaffAccount: (token, id, bool) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Activate-Staff-Account?staffId=${id}&activate=${bool}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getStaffList: (token, id) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Staff-List?schoolId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getStaffWithRoleSetUp: (token, id) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Get-Staffs-WithRoleSetUp?schoolId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getStaffContactList: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Staff-Contact-List/${schoolId}`
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // done
  getSchoolDepartments: (token, schoolId, categoryId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/School-Departments/${categoryId}?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  // Get Staff Categories One 1
  getStaffAccountCategories: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Staff-Account-Categories`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // Get All Staff Roles Categorized By Staff Categories Two Don't To Add DepartmentId
  getRoles: (token, categoryId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/Roles?CategoryId=${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // Roles Setup Three
  addRoleSetups: (data, token) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelUserSetup/Add-RoleSetups`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // Get Setups For Staff Roles
  getUserRolesSetUps: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPaneluserSetup/UserRoleSetUps`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  postSetupStaffAccount: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/SetUp-StaffAccount`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getStaffRoleSetups: (token, id) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/StaffRoleSetups?phoneNumber=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  updateStaffRoleSetups: (data, token) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UpdateStaffRoleSetUps`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteStaffRole: (token, staffId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Delete-StaffRole?staffId=${staffId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  contactList: (token, id) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Staff-Contact-List/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getUsersCredential: (token, schoolId, accountType) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Users-Credential?schoolId=${schoolId}&accountType=${accountType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getUserCredential: (token, schoolId, accountType, phone) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetUserCredential?schoolId=${schoolId}&accountType=${accountType}&phoneNumber=${phone}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  searchUserCredential: (token, schoolId, accountType, searchQuery) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/SearchUser/${accountType}?schoolId=${schoolId}&Searchitem=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  activateStudent: (token, schoolId, phone, bool) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Activate-Deactivate-Student-Account?schoolId=${schoolId}&PhoneNumber=${phone}&activate=${bool}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  activateParent: (token, phone, bool) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Activate-Deactivate-Parent-Account?PhoneNumber=${phone}&activate=${bool}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  editCredentials: (token, data, accountType) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UpdateUserCredential/${accountType}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  createStaff: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/CreateStaff`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  createParent: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/CreateParentProfile`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  // ...................................................DASHBOARD COUNT.........................// 
  getDashboardClass: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/Classes`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardSubject: (token, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/${classId}/Subjects`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardRegisteredSchool: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/RegisteredSchool`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardActivePopulation: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/ActiveStudentPopulation`, {
      params: {
        SchoolId: schoolId,
        PageNumber: pageNumber,
        PageSize: pageSize
      },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch active students",
        data: null
      })),
  getDashboardInActivePopulation: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/InActiveStudentPopulation`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardHostels: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetHostels`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardPendingAdmission: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/PendingAdmission`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardActiveParentPopulation: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/ActiveParentPopulation`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetStaffsDOB: (token, day, month, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetStaffsDOB`, {
      params: { Day: day, Month: month, ClassId: classId, SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardInActiveParentPopulation: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/InActiveParentPopulation`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetDepartments: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetDepartments`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetTeachingStaffs: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetTeachingStaffs`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetNonTeachingStaffs: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetNonTeachingStaffs`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetRoles: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetRoles`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetStaffsRoles: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetStaffsRoles`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize, },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetStaffsWithoutRoles: (token, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetStaffsWithoutRoles`, {
      params: { SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetClassworks: (token, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetClassworks`, {
      params: { ClassId: classId, SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetGetSubmittedClassworks: (token, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetGetSubmittedClassworks`, {
      params: { ClassId: classId, SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetAssignments: (token, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetAssignments`, {
      params: { ClassId: classId, SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),
  getDashboardGetGetSubmittedAssignments: (token, classId, schoolId, pageNumber = 1, pageSize = 10) =>
    axiosClient.get(`${endpoint_two}/api/v${api_version}/Dashboard/GetGetSubmittedAssignments`, {
      params: { ClassId: classId, SchoolId: schoolId, PageNumber: pageNumber, PageSize: pageSize },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => ({
        status: true,
        statusCode: 2,
        data: res.data,
        message: "Success"
      }))
      .catch(err => ({
        status: false,
        statusCode: err.response?.status || 500,
        message: err.response?.data?.message || "Failed to fetch classes",
        data: null
      })),

  // ...........................................................................................// 

  getSelectedSchool: (token, phoneNumber, priviledgeId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetSelectedSchools?phoneNumber=${phoneNumber}&activ=${priviledgeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getUnSelectedSchool: (token, phoneNumber) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetUnSelectedSchools?phoneNumber=${phoneNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addDeleteSchoolStaff: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AddDeleteselectedschools`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getSelectedDepartment: (token, phoneNumber, priviledgeId, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AllSelectedDepartments?schoolId=${schoolId}&phoneNumber=${phoneNumber}&activ=${priviledgeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getUnSelectedepartment: (token, phoneNumber, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AllUnSelectedDepartments?phoneNumber=${phoneNumber}&schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addDeleteDepartmentStaff: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AddDeleteselectedDepartments`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getUserGuides: (token, accountType) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetUserGuide?accounttype=${accountType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getUserGuideLink: (token, accountType, qid) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetUserguideLink?accounttype=${accountType}&qid=${qid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getResultSummaries: (token, schoolId, sessionId, classId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/ResultSummaries?schoolId=${schoolId}&sessionId=${sessionId}&classId=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  DownloadResult: (token, currentTermId, schoolId, sessionId, classId) =>
    axiosClient
      .get(
        `https://lasmabadmindev.azurewebsites.net/api/v1/Results/DownloadResult?currentTermId=${currentTermId}&schoolId=${schoolId}&sessionId=${sessionId}&classId=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob', // Handle binary response (PDF)
        }
      )
      .then((res) => res)
      .catch((err) => err.response),



  publishResult: (token, id, bool) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/Set-RSummary/${id}?setPublish=${bool}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  LockResult: (token, id, bool) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelLasmabSetup/Set-LockSummary/${id}?setLock=${bool}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  GenerateResult: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Results/GenerateStudentResult`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  ReverseResult: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Results/Reverse-Result`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignAdmission: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign-AdmissionNumber`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  removeAdmission: (token, schoolId, studentId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/RemoveAdmissionNumber?schoolId=${schoolId}&studentId=${studentId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  dashboardCount: (token, phoneNumber, departId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/GetStaffDepartmentDashboardItems?phoneNumber=${phoneNumber}&departmentID=${departId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignDefaultSchoolToStaff: (token, schoolId, staffId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AssignDefaultSchooltoStaff?schoolID=${schoolId}&staffID=${staffId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignDefaultClassToStaff: (token, schoolId, staffId, classId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AssignDefaultClass-toClassTeacher?schoolID=${schoolId}&staffID=${staffId}&classId=${classId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  assignAdmissionStudentList: (token, schoolId, classId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AssignAdmissionNumber/StudentList?schoolId=${schoolId}&classId=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  hostelAccomodationStudentsList: (token, schoolId, classId, sessionId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Hostel/GetStudent-ForHostelAllocation?schoolId=${schoolId}&classId=${classId}&sessionId=${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getAllHostels: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Hostel/GetHostels?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  clearCredential: (token, accountType, userId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/ClearUserCredentials/${accountType}?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getTopicsQuestions: (token, type) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UserGuide/${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addTopicQuestion: (token, data, type) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UserGuide/${type}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  createResultSummary: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/CreateResultSummary`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getSessionTermPeriod: (token, schoolId, sessionId, termId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Get-SessionTermPeriod?schoolId=${schoolId}&sessionId=${sessionId}&termId=${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addUpdateTermPeriod: (token, data, type) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/${type}-SessionTermPeriod`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteTopicStepQuestion: (token, type, id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UserGuide/${type}?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getAttendanceSetupDates: (token, schoolId, sessionId, termId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AttendanceSetup/getDates?schoolId=${schoolId}&sessionId=${sessionId}&termId=${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addAttendanceSetupDate: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AttendanceSetup/Add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  lockAttendanceSetupDate: (token, attendanceId, setLock) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AttendanceSetup/Lock-UnLock?attendanceId=${attendanceId}&setLock=${setLock}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteAttendanceSetupDate: (token, id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AttendanceSetup/Delete?attendanceId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getHostelsForManagers: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AssignHostelmanager/getHostels?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignHostelManager: (token, schoolId, staffId, hostelId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign-hostelManager?schoolId=${schoolId}&staffId=${staffId}&hostelId=${hostelId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  unAssignHostelManager: (token, schoolId, hostelId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/UnAssign-hostelManager?schoolId=${schoolId}&hostelId=${hostelId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getSchoolsForPrincipalOrVice: (token, vp) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign${vp ? "-Vice" : ""
        }Prinpal/getSchools`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  unAssignPrincipalOrVice: (token, staffId, vp) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/UnAssign-${vp ? "Vice" : ""
        }Principal?staffId=${staffId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignPrincipal: (token, schoolId, staffId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign-Principal?schoolId=${schoolId}&staffId=${staffId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  assignVicePrincipal: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign-VicePrincipal`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getSchoolDepartmentsForHod: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AssignHod/getdepartments?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  unAssignHod: (token, schoolId, staffId, departmentId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/UnAssign-Hod?schoolId=${schoolId}&staffid=${staffId}&departmentId=${departmentId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  assignHod: (token, schoold, staffId, departmentId) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/Assign-Hod?schoolId=${schoold}&staffId=${staffId}&departmentId=${departmentId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  createDepartment: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/Createdepartment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  editDepartment: (token, { departmentName, Id }) =>
    axiosClient
      .put(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/UpdatedepartmentName?Id=${Id}&departmentName=${encodeURIComponent(departmentName)}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteDepartment: (token, id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/deletedepartment?id=${id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getYearTutors: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/GetYearTutors?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  assignYearTutor: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetup/AddYearTutor`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getSingleResultStudents: (token, schoolId, classId, termId, sessionId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Results/GenerateSingleResult/studentList?schoolId=${schoolId}&classId=${classId}&termId=${termId}&sessionId=${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  GenerateSingleResult: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Results/GenerateStudentResult-Single`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  ValidateResult: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Results/Validate-Generate-Result`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  ReverseSingleResult: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Results/Reverse-Result-Single`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getAuditReport: (
    token,
    {
      pageNumber = 1,
      pageSize = 10,
      email = "",
      name = "",
      phoneNumber = "",
      from = "",
      to = "",
      operation = "",
    }
  ) => {
    if (!email && !name && !phoneNumber) {
      throw new Error(
        "At least one parameter (email, name, or phoneNumber) is required"
      );
    }

    if (from && !to) {
      throw new Error("'to' date is required when 'from' date is provided");
    }

    if (to && !from) {
      throw new Error("'from' date is required when 'to' date is provided");
    }
    const params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      ...(email && { Email: email }),
      ...(name && { Name: name }),
      ...(phoneNumber && { PhoneNumber: phoneNumber }),
      ...(operation && { OperationId: operation }),
      ...(from && { From: from }),
      ...(to && { To: to }),
    };
    const queryString = new URLSearchParams(params).toString();
    return axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/ControlPanelStaffAccountSetUp/AuditReport/Search?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((error) => {
        const errorMessage = error.response
          ? error.response.data.errors
            ? Object.values(error.response.data.errors).flat().join(", ")
            : error.response.data.title || error.response.data.message
          : error.message;
        throw new Error(errorMessage);
      });
  },
};